import styles from "./copyIcon.module.scss";
import copyIcon from "../../images/copy.svg";
import {
  useEffect,
  useRef,
  useState
} from "react";
import { Popup } from "../popup/popup";
import { useTranslation } from "react-i18next";

type CopyIconProps = {
  text: string;
}

export const CopyIcon = ({ text }: CopyIconProps) => {
  const { t } = useTranslation();

  const mainContainer = useRef<HTMLDivElement>(null);

  const timeout = useRef<NodeJS.Timeout>();
  const [showPopup, setShowPopup] = useState<boolean>(false);

  useEffect(() => {
    if (showPopup) {
      runTimeout();
    }
  }, [showPopup]);

  const onClickCopy = (): void => {
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      unsecuredCopyToClipboard(text);
    }
    setShowPopup(true);
    if (!!timeout.current) {
      clearTimeout(timeout.current);
      runTimeout();
    }
  }

  const runTimeout = () => {
    timeout.current = setTimeout(() => {
      setShowPopup(false);
      timeout.current = undefined;
    }, 3000);
  }

  const unsecuredCopyToClipboard = (text: string) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  }

  return (
    <div className={styles.container}
         ref={mainContainer}
         onClick={onClickCopy}>
      <img src={copyIcon} alt=""/>
      <Popup isShow={showPopup}
             classContainer={styles.popup}
             left={-58}
             top={6}
             parent={mainContainer.current}
             child={t("common.copiedToClipboard")}
      />
    </div>
  );
}